import gql from 'graphql-tag'
import {
	user as userFragment,
	permissions as permissionsFragment
} from './fragments'

export default gql`
query getUser($id: ID!) {
	cashAssist {
		getUser(id: $id) {
			id
			mod_ver
			...usermain
			...permissions
			waiterKey
			cashRegisterId,
			monthlyTaxFreeAmount
		}
	}
}
${userFragment}
${permissionsFragment}`

